/** 打开充值弹窗前由入口写入，DepositDialog 打开时消费一次 */
let pendingDepositOpenTrigger = 'app';

/** @param {string} trigger nav | account | trade | create_market | app | … */
export function setDepositOpenTrigger(trigger) {
  const next = String(trigger ?? '').trim();
  pendingDepositOpenTrigger = next || 'app';
}

/** @returns {string} */
export function consumeDepositOpenTrigger() {
  const trigger = pendingDepositOpenTrigger || 'app';
  pendingDepositOpenTrigger = 'app';
  return trigger;
}

/** @type {null | ((opts?: { trigger?: string }) => boolean | Promise<boolean>)} */
let openGlobalDepositFn = null;

/**
 * App 挂载时 register；业务侧只调 openGlobalDepositDialog。
 * @param {null | ((opts?: { trigger?: string }) => boolean | Promise<boolean>)} handler
 */
export function setOpenGlobalDepositDialog(handler) {
  openGlobalDepositFn = typeof handler === 'function' ? handler : null;
}

/**
 * 打开 App 壳上的 DepositDialog（含登录 / 托管门控，与顶栏充值一致）
 * @param {{ trigger?: string }} [opts]
 * @returns {Promise<boolean>}
 */
export async function openGlobalDepositDialog(opts = {}) {
  if (!openGlobalDepositFn) {
    console.warn('[deposit] global dialog handler not registered');
    return false;
  }
  try {
    return Boolean(await openGlobalDepositFn(opts));
  } catch (err) {
    console.warn('[deposit] open global dialog failed', err);
    return false;
  }
}
